import React from 'react';
import { Card, CardHeader } from '@chakra-ui/react';
import { UiKit } from '@datavant/uikit';
import { Button } from '@datavant/dart';
import { useRouter } from 'next/router';
import { trpc } from '../../../utils/trpc';
import { CustomIcons } from '../../CustomIcons';

export const EmrNotSelectedComponent = (props: {
    isSideNavOpen: boolean;
    setIsDfModalOpen: (isOpen: boolean) => void;
}) => {
    const router = useRouter();

    const { data } = trpc.requestManager.rmRouter.getDigitalEligibleRequestCounts.useQuery();

    const style = {
        border: `1px solid UiKit.consistency.success05`,
        backgroundColor: UiKit.consistency.success05,
        paddingRight: 0,
    };

    return props.isSideNavOpen ? (
        <Card maxHeight={'40vw'}>
            <CardHeader paddingY={UiKit.consistency.halfBuffer}>
                <UiKit.Text.Heading3 text="Save Time with AutoFulfillment" />
            </CardHeader>
            <UiKit.Chakra.VStack spacing={UiKit.consistency.halfBuffer}>
                <UiKit.Chakra.VStack
                    width={'100%'}
                    justifyContent={'space-between'}
                    paddingX={UiKit.consistency.buffer}
                >
                    {data && data.eligible !== 0 && (
                        <UiKit.Chakra.VStack spacing={0} align={'stretch'} width={'100%'}>
                            <UiKit.Text.Heading1 text={data.eligible.toString()} />
                        </UiKit.Chakra.VStack>
                    )}
                    <UiKit.Chakra.VStack spacing={0} align={'stretch'}>
                        <UiKit.Text.BodyRegular color={UiKit.consistency.gray50}>
                            {data && data.eligible !== 0 && `out of ${data.total.toString()}`} current and
                            past requests could have been completed automatically
                        </UiKit.Text.BodyRegular>
                    </UiKit.Chakra.VStack>
                </UiKit.Chakra.VStack>
                <UiKit.Chakra.HStack
                    style={style}
                    width={'100%'}
                    spacing={0}
                    paddingX={UiKit.consistency.buffer}
                    paddingY={UiKit.consistency.halfBuffer}
                >
                    <UiKit.Chakra.Box width={150}>
                        <UiKit.Text.BodyRegular>Automate open and future requests</UiKit.Text.BodyRegular>
                    </UiKit.Chakra.Box>
                    <Button
                        appearance={'solid'}
                        bg={'blue.5'}
                        onClick={() => props.setIsDfModalOpen(true)}
                        data-pendo-id={'checkEmrEligibilityButton'}
                        size={'xs'}
                        p={4}
                        w={'24px'}
                        h={'24px'}
                        miw={'24px'}
                    >
                        {CustomIcons.arrowRight({ fill: '#ffffff' })}
                    </Button>
                </UiKit.Chakra.HStack>
                <UiKit.Chakra.VStack
                    paddingX={UiKit.consistency.buffer}
                    paddingBottom={UiKit.consistency.halfBuffer}
                >
                    <UiKit.Text.Normal>
                        Learn more about
                        <UiKit.Text.Clickable
                            text={' Auto Fulfillment'}
                            onClick={() => router.push('/autofulfill-info')}
                        />
                    </UiKit.Text.Normal>
                </UiKit.Chakra.VStack>
            </UiKit.Chakra.VStack>
        </Card>
    ) : null;
};
